var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { APPEvent } from "@/events/AppEvents";
import { Apphandler } from "@/ipc/MainAppHandler";
import { FileDownloadType } from "@/share/FileRequest";
import { LetrwingCrypto } from "@@/LetrwingCommonCrypto";
import { isIpadScreen, testIsMobile } from "@@/Util";
import { makeObservable, observable, action } from "mobx";
import { FloatingPdfPageStore } from "@/app/UIComponents/PdfPagestore";
import { VirtuStatus } from "@/app/admin/uistore/AdminDocumentDetailStore";
import { AdminFloatingPdfConatinerState } from "../UIComponents/AdminFloatingPdfContainer";
export class AdminFloatingObjectViewerState {
    constructor() {
        this.width = testIsMobile() || isIpadScreen() ? window.innerWidth - 50 : window.innerWidth / 2;
        this.left = isIpadScreen() ? 20 : 100;
        this.top = 100;
        this.dragging = false;
        this.title = "";
        this.show = false;
        this.draftid = "";
        this.isViewable = false;
        this.hasVirus = VirtuStatus.Unknown;
        this.isexcel = false;
        this.hasviewercontent = false;
        this.loadingexcelcontent = false;
        this.inqueue = false;
        this.queued = false;
        this.showcomments = false;
        this.linkingmode = false;
        this.selectionmode = false;
        this.size = 0;
        this.activedocumentid = "";
        this.loading = false;
        this.showwatermakr = false;
        this.watermakr = "";
        this.pdfpagesdetails = [];
        this.spreadhseetcontnt = "";
        this.activeuserid = "";
        this.activelterid = "";
        makeObservable(this);
        APPEvent.addSubscriberForLetrUserChanged((useird) => {
            this.activeuserid = useird;
        });
        APPEvent.addSubscriberForAdminLetrChanged((letr) => {
            if (this.activelterid !== letr.id) {
                this.activelterid = letr.id;
                this.reset();
            }
        });
        APPEvent.addSubscriberForAdminPdfFilePage((res) => {
            if (!res.ischooser || res.userid !== this.activeuserid) {
                return;
            }
            setTimeout(() => {
                var _a;
                if (this.loadingexcelcontent && res.id === ((_a = this.info) === null || _a === void 0 ? void 0 : _a.fileid) &&
                    res.pagename === 'viewer') {
                    let page = "";
                    if (res.page !== undefined) {
                        page = LetrwingCrypto.fromBase64ToUTF8(LetrwingCrypto.fromBase64ToUTF8(res.page));
                    }
                    this.spreadhseetcontnt = page;
                    APPEvent.publishAdminSpreadsheetCon({
                        content: page,
                        readonly: true,
                        floating: true,
                        userid: res.userid
                    });
                    this.setLoadingExcelContent(false);
                }
            }, 100);
        });
        APPEvent.addSubscriberForAdminDownload((res) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
            if (res.id === ((_a = this.info) === null || _a === void 0 ? void 0 : _a.fileid) &&
                res.letrid === this.info.letrid && res.ischooser && res.userid === this.activeuserid) {
                if (res.requesttype === FileDownloadType.Metadata) {
                    if (res.info !== undefined && res.info.ingestunboxed !== undefined) {
                        this.pdfpagesdetails = res.info.ingestunboxed.detail;
                        this.enableWatermark(((_b = res.info) === null || _b === void 0 ? void 0 : _b.watermarkstr) !== undefined);
                        this.setWatermark((_e = (_d = (_c = res.info) === null || _c === void 0 ? void 0 : _c.watermarkstr) === null || _d === void 0 ? void 0 : _d.watermark) !== null && _e !== void 0 ? _e : '');
                        AdminFloatingPdfConatinerState.setActiveFileKey((_g = (_f = this.info) === null || _f === void 0 ? void 0 : _f.accesskey) !== null && _g !== void 0 ? _g : "");
                        AdminFloatingPdfConatinerState.setActiveFileId((_j = (_h = this.info) === null || _h === void 0 ? void 0 : _h.fileid) !== null && _j !== void 0 ? _j : "");
                        AdminFloatingPdfConatinerState.setActiveUserId(this.activeuserid);
                        AdminFloatingPdfConatinerState.setActiveLetrId(this.activelterid);
                        FloatingPdfPageStore.activefileid = (_l = (_k = this.info) === null || _k === void 0 ? void 0 : _k.fileid) !== null && _l !== void 0 ? _l : "";
                        if (!res.info.ingestunboxed.haspdf &&
                            res.info.ingestunboxed.hasviewer && res.info.ingestunboxed.isExcel) {
                            this.loadExcelContent();
                            this.setIsExcel(true);
                        }
                        else {
                            this.setViewable(res.info.ingestunboxed.haspdf);
                            this.setIsExcel(false);
                        }
                        this.setQueued(false);
                        this.checkAndGetBookmarks();
                        AdminFloatingPdfConatinerState.setPdfPageDetails(this.pdfpagesdetails);
                    }
                    else {
                        this.setViewable(false);
                        this.setHasViewerContent(false);
                        this.setQueued(true);
                        AdminFloatingPdfConatinerState.setPdfPageDetails([]);
                    }
                    this.setLoading(false);
                }
            }
        });
    }
    setWatermark(mark) {
        this.watermakr = mark;
    }
    enableWatermark(enable) {
        this.showwatermakr = enable;
    }
    setShowComments(show) {
        this.showcomments = show;
    }
    setLoadingExcelContent(loading) {
        this.loadingexcelcontent = loading;
    }
    setLinkingmode(linking) {
        this.linkingmode = linking;
    }
    setSelectionmode(linking) {
        this.selectionmode = linking;
    }
    setIsExcel(excel) {
        this.isexcel = excel;
    }
    setViewable(vable) {
        this.isViewable = vable;
    }
    setQueued(sum) {
        this.queued = sum;
    }
    setInQueue(inqueue) {
        this.inqueue = inqueue;
    }
    checkAndGetBookmarks() {
        if (this.info === undefined) {
            return;
        }
        const req = {
            id: this.info.fileid,
            pagename: "bookmarks",
            pagenumber: -1,
            accesskey: this.info.accesskey,
            ischooser: true,
            userid: this.activeuserid
        };
        Apphandler.sendMessage("adminpdfpage", req);
    }
    downloadMetadata() {
        var _a;
        if (this.loading || this.info === undefined) {
            return;
        }
        this.setLoading(true);
        const req = {
            letrid: this.info.letrid,
            id: this.info.fileid,
            size: this.size,
            accesskey: (_a = this.info.accesskey) !== null && _a !== void 0 ? _a : "",
            requesttype: FileDownloadType.Metadata,
            isChooser: true,
            userid: this.activeuserid
        };
        Apphandler.sendMessage("admindownloadfile", req);
    }
    loadExcelContent() {
        if (this.info === undefined) {
            return;
        }
        this.setLoadingExcelContent(true);
        const req = {
            id: this.info.fileid,
            pagename: "viewer",
            pagenumber: -1,
            accesskey: this.info.accesskey,
            ischooser: true,
            userid: this.activeuserid
        };
        Apphandler.sendMessage("adminpdfpage", req);
    }
    setActiveDocumentId(id) {
        this.activedocumentid = id;
    }
    setDraftId(id) {
        this.draftid = id;
    }
    setLoading(loading) {
        this.loading = loading;
    }
    setShow(show) {
        this.show = show;
    }
    setTitle(title) {
        this.title = title;
    }
    setDragging(dragging) {
        this.dragging = dragging;
    }
    setHasViewerContent(has) {
        this.hasviewercontent = has;
    }
    setLeft(left) {
        this.left = left;
    }
    setTop(top) {
        this.top = top;
    }
    setWidth(width) {
        this.width = width;
    }
    reset() {
        this.setLoading(false);
        this.info = undefined;
        this.setActiveDocumentId("");
        this.setDraftId("");
        this.setLoadingExcelContent(false);
        this.setLeft(isIpadScreen() ? 20 : 100);
        this.setTop(100);
        this.setIsExcel(false);
        this.pdfpagesdetails = [];
        this.title = "";
        this.setSelectionmode(false);
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingObjectViewerState.prototype, "width", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingObjectViewerState.prototype, "left", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingObjectViewerState.prototype, "top", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingObjectViewerState.prototype, "dragging", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingObjectViewerState.prototype, "title", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingObjectViewerState.prototype, "show", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingObjectViewerState.prototype, "draftid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingObjectViewerState.prototype, "isViewable", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingObjectViewerState.prototype, "hasVirus", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingObjectViewerState.prototype, "isexcel", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingObjectViewerState.prototype, "hasviewercontent", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingObjectViewerState.prototype, "loadingexcelcontent", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingObjectViewerState.prototype, "inqueue", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingObjectViewerState.prototype, "queued", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingObjectViewerState.prototype, "showcomments", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingObjectViewerState.prototype, "linkingmode", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingObjectViewerState.prototype, "selectionmode", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingObjectViewerState.prototype, "activedocumentid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingObjectViewerState.prototype, "loading", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingObjectViewerState.prototype, "showwatermakr", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminFloatingObjectViewerState.prototype, "watermakr", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminFloatingObjectViewerState.prototype, "setWatermark", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingObjectViewerState.prototype, "enableWatermark", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingObjectViewerState.prototype, "setShowComments", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingObjectViewerState.prototype, "setLoadingExcelContent", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingObjectViewerState.prototype, "setLinkingmode", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingObjectViewerState.prototype, "setSelectionmode", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingObjectViewerState.prototype, "setIsExcel", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingObjectViewerState.prototype, "setViewable", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingObjectViewerState.prototype, "setQueued", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingObjectViewerState.prototype, "setInQueue", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminFloatingObjectViewerState.prototype, "setActiveDocumentId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminFloatingObjectViewerState.prototype, "setDraftId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingObjectViewerState.prototype, "setLoading", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingObjectViewerState.prototype, "setShow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminFloatingObjectViewerState.prototype, "setTitle", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingObjectViewerState.prototype, "setDragging", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminFloatingObjectViewerState.prototype, "setHasViewerContent", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], AdminFloatingObjectViewerState.prototype, "setLeft", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], AdminFloatingObjectViewerState.prototype, "setTop", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], AdminFloatingObjectViewerState.prototype, "setWidth", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AdminFloatingObjectViewerState.prototype, "reset", null);
